// One place for links used across the site
export const APP_VERSION = '3.0';

export const STORE_LINKS = {
  ios: 'https://apps.apple.com/us/app/yappyli/id6762079641',
  android: 'https://play.google.com/store/apps/details?id=com.yappyli&pcampaignid=web_share',
};

// Files in /public are served from the site root, so no "/public" prefix
export const DESKTOP_DOWNLOADS = {
  mac: { name: 'macOS', href: '/downloads/Yappyli%20Desktop-1.0.0-arm64.dmg' },
  windows: { name: 'Windows', href: '/downloads/Yappyli%20Desktop-1.0.0%20Setup.exe' },
};

export const CONTACT_EMAIL = 'support@yappyli.com';
export const OPERATOR = 'Freedworks';
